<template>
  <form :id="id" ref="register_sbk_account" class="mx-auto max-w-3xl p-8">
    <div class="">
      <div>
        <h3 class="textHeadline3 mt-5 mb-2">{{ title }}</h3>
      </div>
      <div v-for="(element, index) in form" :key="index">
        <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
          <form-element
            :id="addFormPrefix(element.name)"
            ref="formElement"
            :key="index"
            v-model="element.value"
            :type="element.type"
            :label="getFormElementLabel(element)"
            :name="element.name"
            :required="element.required"
            :error-message="translateError(element.error)"
            :choices="element.choices"
            :children="element.children"
          ></form-element>

          <div
            v-if="
              id === 'formDataRegistrationExisting' &&
              element.name === 'password'
            "
            class="sm:col-span-6 -mt-8 text-right"
          >
            <router-link
              :to="{ name: 'sbkPasswordResetStart' }"
              class="hover:underline decoration-2 underline-offset-4 decoration-bkk-100 inline-flex"
            >
              {{ $t("ssosbk.passwordreset.button.text") }}
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <p
      v-if="id !== 'formDataRegistrationExisting' && error[0]"
      class="mt-2 text-sm text-action-red"
    >
      {{ error[0] }}
    </p>
    <button
      class="mt-10 w-full col-span-2 button-bkk-100 !text-background button-primary"
      :class="submitDisabled && 'button-disabled'"
      :disabled="submitDisabled"
      @click.prevent="submit()"
    >
      Registrieren
    </button>
    <button
      v-if="id === 'formDataRegistrationExisting'"
      class="button-secondary w-full mt-2 !text-background"
      @click="
        (e) => {
          e.preventDefault();
          resendActivationMailModalOpen = true;
        }
      "
    >
      {{ $t("ssosbk.resendActivationMail.button") }}
    </button>
    <ResendActivationMailModal
      v-if="id === 'formDataRegistrationExisting'"
      :open="resendActivationMailModalOpen"
      @close="resendActivationMailModalOpen = false"
    />
  </form>
</template>

<script>
import FormElement from "../form/FormElement.vue";
import ResendActivationMailModal from "../sbk/ResendActivationMailModal.vue";

export default {
  name: "RegistrationForm",
  components: { ResendActivationMailModal, FormElement },
  props: {
    form: Array,
    id: String,
    title: String,
    error: Array,
  },
  emits: ["submit-register"],
  data() {
    return {
      formElement: null,
      submitDisabled: false,
      resendActivationMailModalOpen: false,
    };
  },
  mounted() {
    this.formular = this.$refs.register_sbk_account;
  },
  methods: {
    addFormPrefix(id) {
      return id + "-" + this.id;
    },
    removeFormPrefix(id) {
      return id.split("-" + this.id)[0];
    },
    submit() {
      if (this.formular.reportValidity()) {
        let formattedForm = this.formattedFormData();

        this.submitDisabled = true;
        setTimeout(() => {
          this.submitDisabled = false;
        }, 4000);
        this.$emit("submit-register", formattedForm);
      }
    },
    formattedFormData() {
      if (this.formular) {
        let formattedForm = {};
        let compoundElements = {};
        const formData = new FormData(this.formular);

        // override checkbox value defaults
        formattedForm.adApproval = false;
        formattedForm.dataConsent = false;
        formData.forEach((value, key) => {
          formattedForm[this.removeFormPrefix(key)] =
            value === "on" ? true : value;
        });

        // only submit the ID of the campaign, not its full name
        formattedForm.atmCampaign =
          this.$route.params.atmCampaign.split("-")[0];

        // find all compound elements and group them
        [...this.formular.elements].forEach((elem) => {
          if (elem.id.indexOf("[") !== -1 && elem.id.indexOf("]") !== -1) {
            const compoundName = this.extractCompoundName(elem.id);
            if (!compoundElements.hasOwnProperty(compoundName)) {
              compoundElements[compoundName] = [];
            }

            compoundElements[compoundName].push(elem);
          }
        });

        // combine the values of all elements of one compound, add them as one key and remove the separate parts
        for (const compound in compoundElements) {
          let value = {};
          compoundElements[compound].forEach((elem) => {
            const rawPropertyName = elem.id.substring(
              elem.id.indexOf("[") + 1,
              elem.id.indexOf("]")
            );
            value[rawPropertyName] = elem.value;

            delete formattedForm[elem.id];
          });
          formattedForm[compound] = value;
        }

        return formattedForm;
      }

      return null;
    },
    scrollToError() {
      this.$refs.formElement.forEach((element) => {
        element.scrollToError();
      });
    },
    translateError(error) {
      return error === null
        ? null
        : this.$t(this.$sbkManager.translateSbkRegistrationError(error));
    },
    getFormElementLabel(element) {
      // hardcoded links, :name parameter for the route should never change though, so only route path is volatile
      return element.label
        .replace(
          "Teilnahmeerklärung",
          '<a href="/sbk/site/teilnahmebedingungen-mein-phileo" target="_blank">Teilnahmeerklärung</a>'
        )
        .replace(
          "Datennutzung",
          '<a href="/sbk/site/datenschutz-mein-phileo" target="_blank">Datennutzung</a>'
        );
    },
    extractCompoundName(value) {
      return value.substring(0, value.indexOf("["));
    },
  },
};
</script>
